import DefaultAuthPage from './DefaultAuthPage';

export default DefaultAuthPage;
